/* lazy loading for snippets/responsive-video.liquid */
window.lazyVideo = window.lazyVideo || (function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(video) {
    if (!video || video.hasAttribute('data-loaded')) return;
    video.setAttribute('data-loaded', '');
    if (video.dataset.poster) video.poster = video.dataset.poster;
    // reduced motion: poster only
    if (reduceMotion) return;
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
    });
    video.load();
  }

  function play(video) {
    if (!video) return;
    load(video);
    if (reduceMotion) return;
    var attempt = video.play();
    // autoplay blocked (e.g. low-power mode): the poster stays
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  function pause(video) {
    if (video && !video.paused) video.pause();
  }

  // data-autoplay videos play only while on screen
  function watch() {
    document.querySelectorAll('video[data-autoplay]:not([data-watched])').forEach(function (video) {
      video.setAttribute('data-watched', '');
      if (!('IntersectionObserver' in window)) return play(video);
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) play(video);
        else pause(video);
      }).observe(video);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);

  return { load: load, play: play, pause: pause };
})();
